import PdfView from './PdfView';

export default PdfView;
